import { useState, useEffect } from 'react';
import Comments from './Comments';
import { useGetAllCommentsQuery } from '../../../../store/api/commentApi';
import { DEFAULT_AVATAR } from '../../../../utils/constant';

const NoteComments = ({ noteData, replyComment }) => {
  const noteId = noteData._id;
  const [comments, setComments] = useState([]);
  const { data: commentData, isLoading } = useGetAllCommentsQuery(noteId);

  useEffect(() => {
    // reload when the comment is updated in backend
    if (!isLoading) {
      if (commentData.data.length > 0) {
        const formattedData = formatData(commentData.data);
        setComments(formattedData);
      } else {
        setComments([]);
      }
    }
  }, [commentData]);

  const formatData = (data) => {
    return data.map((item) => {
      const id = item._id;
      const text = item.text;
      const postAt = item.postAt;
      const likedUsers = item.likedUsers;
      const parentCommentId = item.parentComment;
      const author = {
        id: item.author._id,
        name: item.author.userName,
        avatar: item.author.avatar || DEFAULT_AVATAR,
      };
      let replyTo;
      if (item.replyTo) {
        replyTo = { id: item.replyTo._id, name: item.replyTo.userName };
      } else {
        replyTo = null;
      }
      return {
        id,
        text,
        postAt,
        likedUsers,
        author,
        replyTo,
        parentCommentId,
      };
    });
  };

  const parentComments = comments.filter((comment) => comment.parentCommentId === undefined);
  const childComments = comments.filter((comment) => comment.parentCommentId !== undefined);

  return (
    <Comments
      noteId={noteId}
      noteAuthorId={noteData.author._id}
      parentComments={parentComments}
      childComments={childComments}
      replyComment={replyComment}
    />
  );
};
export default NoteComments;
